var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m38.664 8.345-6.822-6.407C30.529.71 28.67 0 26.729 0H6.945C3.104 0 0 2.695 0 6.005v37.99c0 3.31 3.104 6.004 6.945 6.004h56.11C66.883 50 70 47.316 70 43.994V14.35c0-3.31-3.103-6.005-6.945-6.005h-24.39Z",
    fill: "#4FB7CF",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.857h70V48.5a1.5 1.5 0 0 1-1.5 1.5h-67A1.5 1.5 0 0 1 0 48.5V17.857Z",
    fill: "#4FB7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.373ba2e29ab740ac572ae5a069292aa9.svg";
export { ForwardRef as ReactComponent };